import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useTrackerApi } from "@/v2/entities/tracker/Tracker.api";
import { TrackerCreateOrUpdateInput } from "@/v2/entities/tracker/Tracker.api";
import TrackerForm from "@/v2/features/tracker/TrackerForm";
import { Tracker } from "@/v2/entities/tracker/Tracker.model";
import { useMutation, useQueryClient } from "react-query";

export default function CreateTrackerPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { createTracker } = useTrackerApi();

  const { mutate: createTrackerMutation, isLoading: isCreatingTracker } =
    useMutation({
      mutationKey: ["createTracker"],
      mutationFn: (data: TrackerCreateOrUpdateInput) => createTracker(data),
      onSuccess: (createdTracker: Tracker) => {
        toast.success("Tracker created successfully");
        navigate(`/trackers/${createdTracker.id}`);
        queryClient.invalidateQueries(["trackers"]);
      },
      onError: (error: any) => {
        toast.error(
          error?.response?.data?.message === "Invalid match rules"
            ? "Failed to create tracker, Capture Rules must be defined."
            : "Failed to create tracker"
        );
      },
    });

  const handleSubmit = useCallback(
    async (data: TrackerCreateOrUpdateInput) => {
      createTrackerMutation(data);
    },
    [createTrackerMutation]
  );

  const handleCancel = useCallback(() => {
    navigate("/trackers");
  }, [navigate]);

  return (
    <TrackerForm
      mode="create"
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      loading={isCreatingTracker}
    />
  );
}
